import Flex from '@react-css/flex';
import type * as Sentry from '@sentry/react';
import Body from 'storybookConfig/stories/molecules/Body';
import PrimaryButton from 'storybookConfig/stories/molecules/Button/PrimaryButton';
import SecondaryButton from 'storybookConfig/stories/molecules/Button/SecondaryButton';
import Heading from 'storybookConfig/stories/molecules/Heading';
import AuthLayout from 'storybookConfig/stories/species/Layout/AuthLayout';

const ErrorSuggestion = ({ message }: { message: string }) => {
  // For https://convictional.sentry.io/issues/4709478990/
  if (message.includes("Failed to execute 'removeChild' on 'Node'")) {
    return (
      <Body as="p" color="errorStrong">
        We&apos;ve noticed that this type of error is thrown when Google Chrome&apos;s Translate
        Page feature is in use.
        <br />
        It might be worth trying another browser, another translation tool, or disable the
        translation feature.
      </Body>
    );
  }

  return null;
};

const AppError: Sentry.FallbackRender = ({ error, resetError }) => {
  const message = (error as Error)?.message ?? '';
  return (
    // The crash page must not depend on the GPU: the still wash, no WebGL field.
    <AuthLayout shader={false}>
      <Flex column gap="24px">
        <Heading variant="Headings/H1">Something went wrong!</Heading>

        <Body as="p">
          Rest assured, we&apos;ve been notified and are looking into this error:
          <br />
          <code>{message}</code>
        </Body>

        <ErrorSuggestion message={message} />

        <Flex gap="16px">
          <SecondaryButton as="a" href="mailto:support@getcarro.com">
            Email support
          </SecondaryButton>

          <PrimaryButton onClick={resetError}>Reset Error</PrimaryButton>
        </Flex>
      </Flex>
    </AuthLayout>
  );
};

export default AppError;
